import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from "@sentry/vue";
import '@/assets/index.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'material-symbols';
import '@vuepic/vue-datepicker';
import App from './App.vue'
import router from './router'

const app = createApp(App);
Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/[^/]*\.pompstire\.com/],
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
  release: import.meta.env.VITE_SENTRY_RELEASE || 'unknown',
  beforeSend: (event) => {
    // Check if the event originated from localhost
    if (window.location.hostname === 'localhost') {
      return null; // Drop the event
    }
    return event; // Send the event
  },
});

app.use(createPinia())
app.use(router);
app.mount('#app');
